<template>
  <div ref="referenceElement">
    <InputDefault
      :id="'search_dropdown_' + id"
      v-model="search"
      :label="label ?? ''"
      type="text"
      pre-icon="MagnifyingGlassIcon"
      :error="error"
      :clear="clear"
      :clear-event="clearEvent"
      :style-input="styleInput"
      v-bind="$attrs"
      @click="$attrs.readonly ? null : openSearchClick()"
      @keyup.enter="(e: Event) => getSearchData()"
    />
    <template v-if="minlength && search && minlength > search.length">
      <span class="text-xs text-gray-300">
        {{ search?.length }}/{{ minlength }}
      </span>
    </template>
  </div>

  <!-- Usar Teleport para renderizar el dropdown fuera del contexto del modal -->
  <Teleport to="body">
    <div
      v-if="isDropdownOpen"
      :id="'dropdown_' + id"
      ref="floatingElement"
      class="z-99999 w-auto min-w-125 max-w-175 bg-white rounded-xl shadow-[0_10px_40px_10px_rgba(0,0,0,0.08)] dark:bg-neutral-800"
      :style="floatingStyles"
    >
    <template v-if="listGroup && tabs">
      <div
        class="overflow-x-auto p-4 rounded-t-xl border-b border-gray-400 [&amp;::-webkit-scrollbar]:h-2 [&amp;::-webkit-scrollbar-thumb]:rounded-full [&amp;::-webkit-scrollbar-track]:bg-gray-100 [&amp;::-webkit-scrollbar-thumb]:bg-gray-300 dark:[&amp;::-webkit-scrollbar-track]:bg-neutral-700 dark:[&amp;::-webkit-scrollbar-thumb]:bg-neutral-500 dark:bg-neutral-800 dark:border-neutral-700"
      >
        <div :id="'tabs_dropdown_' + id" class="flex flex-nowrap gap-x-2">
          <button
            type="button"
            :class="`${groupSelect == 'Todos' ? classBtnAct : classBtnInac}`"
            @click="selectGroup('Todos')"
          >
            Todos
          </button>
          <template v-for="(listGroupItem, nombre) in listGroup" :key="nombre">
            <button
              type="button"
              :class="`${groupSelect == nombre ? classBtnAct : classBtnInac}`"
              @click="selectGroup(nombre)"
            >
              {{ nombre }}
            </button>
          </template>
        </div>
      </div>
    </template>
    <div
      class="max-h-75 p-2 overflow-y-auto overflow-hidden [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300 dark:[&::-webkit-scrollbar-track]:bg-neutral-700 dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500"
    >
      <template v-if="loading">
        <div class="items-center p-4 text-center">
          <div
            class="animate-spin inline-block size-4 border-[3px] border-current border-t-transparent text-blue-600 rounded-full"
            role="status"
            aria-label="loading"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </template>
      <template v-else>
        <slot name="option">
          <template v-if="listGroup">
            <template
              v-for="(listGroupItem, nombre) in (groupSelect == 'Todos' ? listGroup : { [groupSelect]: (listGroup as any)[groupSelect] })"
              :key="nombre"
            >
              <div
                v-if="!tabs"
                class="text-xs uppercase text-gray-500 m-3 mb-1 dark:text-neutral-500"
              >
                {{ nombre }}
              </div>
              <template
                v-for="(option, index) in (listGroupItem as object[])"
                :key="index"
              >
                <div
                  v-if="options.mapOptions"
                  :id="generateId(options, option, index)"
                  :class="[(option as any).deshabilitado ? 'opacity-50 cursor-not-allowed pointer-events-none' : '']"
                  @click="!(option as any).deshabilitado && setValor(generateId(options, option, index), option)"
                >
                  <span
                    class="flex items-center cursor-pointer py-2 px-4 w-full text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:bg-neutral-800 dark:hover:bg-neutral-700 dark:text-neutral-200 dark:focus:bg-neutral-700"
                  >
                    <div class="flex items-center w-full">
                      <div class="grid grid-cols-1">
                        <span class="font-bold">{{
                          options.mapOptions(option).optionText
                        }}</span>
                        <div
                          class="text-xs truncate w-full normal-case font-normal -mt-1"
                          :class="(option as any).deshabilitado && mensajeDeshabilitado ? 'text-red-700' : 'text-gray-500'"
                        >
                          {{ (option as any).deshabilitado && mensajeDeshabilitado ? mensajeDeshabilitado : options.mapOptions(option).optionSubText }}
                        </div>
                      </div>
                    </div>
                    <span class="hidden">
                      <CheckIcon
                        class="shrink-0 size-3.5 text-blue-600 dark:text-blue-500"
                      />
                    </span>
                  </span>
                </div>
                <div
                  v-else
                  :id="generateId(options, option, index)"
                  :class="[(option as any).deshabilitado ? 'opacity-50 cursor-not-allowed pointer-events-none' : '']"
                  @click="!(option as any).deshabilitado && setValor(generateId(options, option, index), option)"
                >
                  <span
                    class="flex items-center cursor-pointer py-2 px-4 w-full text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:bg-neutral-800 dark:hover:bg-neutral-700 dark:text-neutral-200 dark:focus:bg-neutral-700"
                  >
                    <div class="flex items-center w-full">
                      <span>{{
                        options.optionText && option[options.optionText]
                      }}</span>
                    </div>
                    <span class="hidden">
                      <CheckIcon
                        class="shrink-0 size-3.5 text-blue-600 dark:text-blue-500"
                      />
                    </span>
                  </span>
                </div>
              </template>
            </template>
          </template>
          <template v-else-if="list && list.length > 0">
            <template v-for="(option, index) in list" :key="index">
              <div
                v-if="options.mapOptions"
                :id="generateId(options, option, index)"
                :class="[(option as any).deshabilitado ? 'opacity-50 cursor-not-allowed pointer-events-none' : '']"
                @click="!(option as any).deshabilitado && setValor(generateId(options, option, index), option)"
              >
                <span
                  class="flex items-center cursor-pointer py-2 px-4 w-full text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:bg-neutral-800 dark:hover:bg-neutral-700 dark:text-neutral-200 dark:focus:bg-neutral-700"
                >
                  <template v-if="$slots.customOption">
                    <!-- Renderiza el slot con el objeto `customOption` como parámetro -->
                    <slot name="customOption" :option="option"></slot>
                  </template>
                  <template v-else>
                    <!-- Renderizado por defecto -->
                    <div class="flex items-center w-full">
                      <div class="grid grid-cols-1">
                        <span class="font-bold">{{
                          options.mapOptions(option).optionText
                        }}</span>
                        <div class="text-xs truncate w-full normal-case font-normal -mt-1" :class="(option as any).deshabilitado && mensajeDeshabilitado ? 'text-red-700' : 'text-gray-500'">
                          {{ (option as any).deshabilitado && mensajeDeshabilitado ? mensajeDeshabilitado : options.mapOptions(option).optionSubText }}
                        </div>
                      </div>
                    </div>
                  </template>
                  <span class="hidden">
                    <CheckIcon class="shrink-0 size-3.5 text-blue-600 dark:text-blue-500"/>
                  </span>
                </span>
              </div>
              <div
                v-else
                :id="generateId(options, option, index)"
                :class="[(option as any).deshabilitado ? 'opacity-50 cursor-not-allowed pointer-events-none' : '']"
                @click="!(option as any).deshabilitado && setValor(generateId(options, option, index), option)"
              >
                <span
                  class="flex items-center cursor-pointer py-2 px-4 w-full text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:bg-neutral-800 dark:hover:bg-neutral-700 dark:text-neutral-200 dark:focus:bg-neutral-700"
                >
                  <div class="flex items-center w-full">
                    <span>{{
                      options.optionText && option[options.optionText]
                    }}</span>
                  </div>
                  <span class="hidden">
                    <CheckIcon
                      class="shrink-0 size-3.5 text-blue-600 dark:text-blue-500"
                    />
                  </span>
                </span>
              </div>
            </template>
          </template>
          <div
            v-else
            class="p-2 pl-2 cursor-pointer w-full border-gray-100 border-b hover:bg-blue-50"
          >
            Sin resultados
          </div>
        </slot>
      </template>
    </div>
    </div>
  </Teleport>

  <!-- Overlay para cerrar el dropdown al hacer clic fuera -->
  <div
    v-if="isDropdownOpen"
    class="fixed inset-0 z-99998"
    @click="closeDropdown"
  ></div>
</template>
<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount, watch } from 'vue'
import { useFloating, autoUpdate, offset, flip, shift } from '@floating-ui/vue'
import { CheckIcon } from '@heroicons/vue/24/outline'
import { groupBy } from '@/modules/Core/usings/generales'
import type {
  ISelectOption,
  ISelectSearchOptionsProps,
  ISelectSearchProps,
  ServicesType
} from '@/modules/Core/interfaces'
import * as services from '@/services'
const props = defineProps<ISelectSearchProps>()
const {
  id,
  options,
  tabs = false,
  initialData = false,
  isGroup = false, // Sirve para filtrar
  isGrouped = false, // Para indicar que el listado ya viene agrupado
  clear = false,
  groupField,
  groupSearch = false,
  styleInput = 'default',
  minlength,
  mensajeDeshabilitado
} = props
const { action, ruteParams, urlSearch } = options
const search = defineModel<string>('search')
const value = defineModel<unknown>('value')
const list = ref(props.list || [])
const listCopy = ref<object[] | null>([])
const listGroup = ref<object | undefined | null>(props.listGroup)
const listGroupCopy = ref<object | null>(props.listGroup as object | null ?? null)
const loading = ref(false)
const groupSelect = ref('Todos')

// Variables para Floating UI
const isDropdownOpen = ref(false)
const referenceElement = ref()
const floatingElement = ref()

// Configuración de Floating UI
const { floatingStyles } = useFloating(referenceElement, floatingElement, {
  open: isDropdownOpen,
  placement: 'bottom-start',
  middleware: [
    offset(8),
    flip(),
    shift({ padding: 8 })
  ],
  whileElementsMounted: autoUpdate
})

const emit = defineEmits(['cambiarValor', 'customFunction', 'selectRaw'])
defineSlots<{
  option: () => unknown
  customOption: () => unknown
}>()
const { fieldFilter } = options
function generateId(
  options: ISelectSearchOptionsProps,
  option: object,
  i: number
) {
  const value = options.mapOptions
      ? options.mapOptions(option).optionValue
      : options.optionValue && option[options.optionValue]
  return `${id}_OPTION_${value}_${i}`
}
function openSearchClick() {
  const hasDatos = (list.value && list.value.length > 0) || (listGroup.value && Object.keys(listGroup.value).length > 0)

  if (hasDatos) {
    openSearch()
  } else if (!initialData) {
    return
  } else if (initialData) {
    openSearch()
    getSearchData()
  }
}
function selectGroup(valor: string) {
  groupSelect.value = valor
}
function setValor(idElement: string, optionOriginal: object) {
  const option = options.mapOptions
    ? options.mapOptions(optionOriginal)
    : optionOriginal
  search.value = options.mapOptions
    ? (option as ISelectOption).optionText
    : options.optionText && option[options.optionText]
  value.value = options.mapOptions
    ? (option as ISelectOption).optionValue
    : options.optionValue && option[options.optionValue]
  const selects = document.querySelectorAll(
    `[id^="${id + '_OPTION_'}"]`
  ) as NodeListOf<HTMLElement>
  selects.forEach(select => {
    const selectHtml = select as HTMLElement
    selectHtml.classList.remove('bg-blue-100')
    ;(select.lastChild?.lastChild as HTMLElement).classList.add('hidden')
  })
  const selectEl = document.getElementById(idElement) as HTMLElement
  if (selectEl) {
    selectEl.classList.add('bg-blue-100')
    ;(selectEl.lastChild?.lastChild as HTMLElement).classList.remove('hidden')
  }
  emit('cambiarValor', option)
  emit('customFunction', option)
  emit('selectRaw', optionOriginal)
  closeDropdown()
}

function openSearch() {
  isDropdownOpen.value = true
}

function closeDropdown() {
  isDropdownOpen.value = false
}
async function getSearchData() {
  if (minlength && (search.value?.length || 0) < minlength) {
    if (isGroup) {
      listGroup.value = listGroupCopy.value
    } else {
      list.value = listCopy.value || []
    }
    return
  }
  if (!initialData && (!search.value || search.value.trim() === '')) {
    closeDropdown()
    return
  }

  openSearch()
  loading.value = true

  if (!initialData) {
    if (
      search.value &&
      (search.value as string).length > 0 &&
      search.value.toString().replace(/ /g, '') != ''
    ) {
      if (urlSearch && action) {
        const searchParams = {
          search: search.value,
          ...(props.options?.params ?? {})
        }
        const { data } = await (services[urlSearch] as object)[action](
          searchParams,
          ruteParams
        )
        const responseSearch = data.body
        const listData = responseSearch && Array.isArray(responseSearch.rows) ? responseSearch.rows : responseSearch

        if (isGrouped) {
          listGroup.value = listData
        } else if (isGroup) {
          listGroup.value = groupBy<object>(listData, item => {
            return groupField && groupField.mapOptions
              ? groupField.mapOptions(item)
              : groupField && groupField.name && item[groupField.name]
          })
        } else {
          list.value = listData
        }
      }
    } else {
      if (isGroup) {
        listGroup.value = listGroupCopy.value
      } else {
        list.value = listCopy.value || []
      }
    }
  } else {
    const name = fieldFilter?.name
    if (!search.value || search.value.trim() === '') {
      if (isGroup) {
        listGroup.value = listGroupCopy.value
      } else {
        list.value = listCopy.value || []
      }
    } else {
      if (isGroup) {
        if (!listGroupCopy.value) { loading.value = false; return }
        listGroup.value = Object.keys(listGroupCopy.value as object).reduce(
          (acc, key) => {
            const filteredItems = (listGroupCopy.value as object)[key].filter(
              (item: object) => {
                return (
                  (fieldFilter?.mapOptions
                    ? fieldFilter.mapOptions(item)
                    : name && item[name]
                  )
                    .toUpperCase()
                    .indexOf((search.value as string).toUpperCase()) > -1
                )
              }
            )
            if (filteredItems.length > 0) {
              ;(acc as object)[key] = filteredItems
            }
            return acc
          },
          {}
        )
      } else {
        list.value =
          (listCopy.value &&
            listCopy.value.filter(
              item =>
                (fieldFilter?.mapOptions
                  ? fieldFilter.mapOptions(item)
                  : name && item[name]
                )
                  .toUpperCase()
                  .indexOf((search.value as string).toUpperCase()) > -1
            )) ||
          []
      }
    }
  }

  loading.value = false
}
const load = async () => {
  if (groupField) {
    if (urlSearch && groupSearch && action) {
      const { data } = await (services[urlSearch as keyof ServicesType] as object)[action](
        options.params
      )
      listGroupCopy.value = data.body
      listGroup.value = listGroupCopy.value
    } else {
      listGroupCopy.value = listGroup.value as object
    }
  } else {
    if (urlSearch && action) {
      const { data } = await (services[urlSearch as keyof ServicesType] as object)[action](
        options.params
      )
      listCopy.value = data.body
      list.value = listCopy.value || []
    } else {
      listCopy.value = list.value
    }
  }
}
const clearEvent = () => {
  if (props.clearEvent) {
    props.clearEvent()
  }

  search.value = ''
  value.value = null
  listGroup.value = listGroupCopy.value
  list.value = listCopy.value || []
  closeDropdown()
}
watch(
  () => search.value,
  newVal => {
    if (newVal == null || newVal == '') {
      listGroup.value = listGroupCopy.value
      list.value = listCopy.value || []
    }
  }
)
watch(
  () => props.listGroup,
  newValues => {
    if (newValues) {
      listGroupCopy.value = newValues
      listGroup.value = newValues
    }
  }
)
watch(
  () => props.list,
  newValues => {
    if (newValues) {
      listCopy.value = newValues
      list.value = newValues
    }
  }
)

function handleClickOutside(e: Event) {
  const target = e.target as HTMLElement

  if (
    referenceElement.value?.contains(target) ||
    floatingElement.value?.contains(target)
  ) {
    return
  }
  closeDropdown()
}

onMounted(() => {
  if (props.initialData) {
    load()
  }
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})

const classBtnInac =
  'capitalize py-1 px-2 inline-flex items-center gap-x-2 text-sm text-nowrap rounded-md border border-gray-400 bg-white text-gray-600 shadow-sm hover:bg-gray-50 focus:outline-none focus:bg-gray-100 hs-combo-box-tab-active:bg-blue-600 hs-combo-box-tab-active:border-blue-600 hs-combo-box-tab-active:focus:border-blue-600 hs-combo-box-tab-active:text-white disabled:opacity-50 disabled:pointer-events-none dark:hs-combo-box-tab-active:bg-blue-500 dark:hs-combo-box-tab-active:text-white dark:hs-combo-box-tab-active:border-blue-500 dark:hs-combo-box-tab-active:focus:border-blue-500 dark:bg-neutral-800 dark:border-neutral-700 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:focus:bg-neutral-700 --exclude-accessibility'
const classBtnAct =
  'capitalize py-1 px-2 inline-flex items-center gap-x-2 text-sm text-nowrap rounded-md border border-gray-400 bg-white text-gray-600 shadow-sm hover:bg-gray-50 focus:outline-none focus:bg-gray-100 hs-combo-box-tab-active:bg-blue-600 hs-combo-box-tab-active:border-blue-600 hs-combo-box-tab-active:focus:border-blue-600 hs-combo-box-tab-active:text-white disabled:opacity-50 disabled:pointer-events-none dark:hs-combo-box-tab-active:bg-blue-500 dark:hs-combo-box-tab-active:text-white dark:hs-combo-box-tab-active:border-blue-500 dark:hs-combo-box-tab-active:focus:border-blue-500 dark:bg-neutral-800 dark:border-neutral-700 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:focus:bg-neutral-700 --exclude-accessibility active hs-combo-box-tab-active'
</script>
